import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  ToggleWrapper,
  ToggleLabel,
  ToggleButton,
} from "./styles";

const Header = ({
  t,
  is3D,
  setIs3D,
}: {
  t: TFunction;
  is3D: boolean;
  setIs3D: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [visible, setVisibility] = useState(false);

  const handleToggle = () => setIs3D((prev) => !prev);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      if (element) {
        const offset = id === "mission" ? 200 : 50; // Adjust the offset for "mission" as needed
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });

        setVisibility(false);
      }
    };
    return (
      <>
        <CustomNavLinkSmall>
          <Span>{t("Home")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("services")}>
          <Span>{t("Services")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("solutions")}>
          <Span>{t("Solutions")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("mission")}>
          <Span>{t("Mission")}</Span>
        </CustomNavLinkSmall>
        {/* <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{t("Portfolio")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{t("About Us")}</Span>
        </CustomNavLinkSmall> */}

        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => scrollTo("contact")}
        >
          <Span>
            <Button>{t("Contact Us")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="lattice.png" width="auto" height="80" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
      <ToggleWrapper>
        <ToggleButton onClick={handleToggle} active={is3D}>
          <span
            style={{
              textAlign: "left",
              marginLeft: "0.1rem",
            }}
          >
            2D
          </span>
          <span
            style={{
              textAlign: "right",
              marginRight: "0.1rem",
            }}
          >
            3D
          </span>
          <div className="circle" />
        </ToggleButton>
      </ToggleWrapper>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
